import React from 'react';
import T from 'prop-types';
// components
import Link from 'react-router/lib/Link';
import { FormattedMessage } from 'react-intl';
import Button from 'components/Button';
// utils
import classnames from 'classnames/bind';
// styles
import styles from './EmptyStateActions.module.scss';

const cn = classnames.bind(styles);

// Import link next to one primary action, for NothingBox empty states that support CSV import
const EmptyStateActions = ({ importTo, primaryLabel, primaryTo, onPrimaryClick, disabled }) => (
  <div className={cn('EmptyStateActions')}>
    <Link className={cn('button', 'hollow', 'action')} to={importTo}>
      <FormattedMessage id="general.import" />
    </Link>
    {primaryTo ? (
      <Link className={cn('button', 'primary', 'action')} to={primaryTo}>
        {primaryLabel}
      </Link>
    ) : (
      <Button primary className={cn('action')} onClick={onPrimaryClick} disabled={disabled}>
        {primaryLabel}
      </Button>
    )}
  </div>
);

EmptyStateActions.propTypes = {
  importTo: T.string.isRequired,
  primaryLabel: T.node.isRequired,
  primaryTo: T.string,
  onPrimaryClick: T.func,
  disabled: T.bool,
};

EmptyStateActions.defaultProps = {
  disabled: false,
};

export default EmptyStateActions;
